import React from "react";
import classNames from "classnames";

import styles from "./NormalSection.module.scss";

// interface NormalSectionProps extends React.HTMLAttributes<HTMLDivElement> {}

const NormalSection: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
}) => {
  return (
    <div className={classNames(styles.section, className)}>{children}</div>
  );
};

export { NormalSection };
